var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "90fe12b545"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61.03125 73.238281 L 187.78125 73.238281 L 187.78125 199.988281 L 61.03125 199.988281 Z M 61.03125 73.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b8554cac0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 73.238281 L 314.25 73.238281 L 314.25 199.988281 L 187.5 199.988281 Z M 187.5 73.238281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0de234a5f6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.75 199.425781 L 187.5 199.425781 L 187.5 326.175781 L 60.75 326.175781 Z M 60.75 199.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d65fe5f79a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.21875 199.425781 L 313.96875 199.425781 L 313.96875 326.175781 L 187.21875 326.175781 Z M 187.21875 199.425781 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#90fe12b545)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fe7e02",
    d: "M 61.03125 199.972656 C 61.027344 183.328125 64.300781 166.84375 70.667969 151.46875 C 77.035156 136.089844 86.371094 122.117188 98.140625 110.347656 C 109.910156 98.578125 123.882812 89.242188 139.261719 82.875 C 154.640625 76.507812 171.121094 73.234375 187.765625 73.238281 L 187.765625 199.972656 Z M 61.03125 199.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b8554cac0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#45525b",
    d: "M 187.5 199.972656 C 187.496094 183.328125 190.769531 166.84375 197.136719 151.46875 C 203.507812 136.089844 212.839844 122.117188 224.609375 110.347656 C 236.378906 98.578125 250.351562 89.242188 265.730469 82.875 C 281.109375 76.507812 297.589844 73.234375 314.234375 73.238281 L 314.234375 199.972656 Z M 187.5 199.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0de234a5f6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9b24e",
    d: "M 187.5 199.441406 C 187.503906 216.085938 184.226562 232.566406 177.859375 247.945312 C 171.492188 263.324219 162.160156 277.296875 150.390625 289.0625 C 138.621094 300.832031 124.648438 310.167969 109.269531 316.535156 C 93.890625 322.902344 77.410156 326.179688 60.765625 326.175781 L 60.765625 199.441406 Z M 187.5 199.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d65fe5f79a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a8bbc6",
    d: "M 313.96875 199.441406 C 313.972656 216.085938 310.699219 232.566406 304.332031 247.945312 C 297.960938 263.324219 288.628906 277.296875 276.859375 289.0625 C 265.089844 300.832031 251.117188 310.167969 235.738281 316.535156 C 220.359375 322.902344 203.878906 326.179688 187.234375 326.175781 L 187.234375 199.441406 Z M 313.96875 199.441406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8f4ee4a573d11daa86a29f97303d193b.svg";
export { ForwardRef as ReactComponent };